<template lang="pug">
feathers-vuex-find(service="user-musics" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
  v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
    v-card-title Music Lists
      v-spacer
      v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
    v-data-table(
      :headers="headers"
      :loading="isFindPending"
      :items="isFindPending ? [] : desserts"
      :options.sync="pagination"
      :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
      :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
      loading-text="Fetching Data..."
    )
      template(v-slot:item.title="{ item }")
        v-avatar(size="40" tile)
          v-img(:src="item.music_cover_thumb")
        | &nbsp;&nbsp;&nbsp;
        a(:href="`https://www.breakinghits.app/${(item.user.result || { url: '' }).url}`" :target="`__user-${item.id}`" v-html="item.title")

      template(v-slot:item.audio="{ item }")
        audio(controls controlsList="nodownload" style="height: 30px;")
          source(:src="`https://api.breakinghits.com/player/audio/${item.id}`" type="audio/mpeg")

      template(v-slot:item.date_added="{ item }")
        v-chip(small :color="item.featured === 1 ? 'orange' : 'green'" outlined) {{ item.date_added | dateFormat }}

</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      searchUser: '',
      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: false,
          value: 'title'
        },
        {
          text: 'Audio',
          align: 'start',
          sortable: false,
          value: 'audio'
        },
        {
          text: 'Date Added',
          align: 'end',
          sortable: false,
          value: 'date_added'
        }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true]
      },
      query: {},
    };
  },
  filters: {
    dateFormat(date) {
      if (date) {
        return moment(date).format('lll');
      }

      return 'n/a';
    },
    status(status) {
      switch (status) {
        case 0: return 'Inactive';
        case 1: return 'Active';
      }
    }
  },
  computed: {
    extendedQuery() {
      if (this.user) {
        return {
          // id: { $nin: [this.user.id] }
        };
      }
      return null;
    },
    searchQuery() {
      if (this.searchUser) {
        return {
          $or: [
            { title: { $like: `%${this.searchUser}%` } },
          ]
        };
      }
      return null;
    },
    searchDataQuery() {
      if (this.searchUser) {
        return {
          $or: [
            { title: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
          ]
        };
      }
      return null;
    },
    sortingQuery() {
      if (this.pagination.sortBy.length !== 0) {
        const $sort = {};
        this.pagination.sortBy.map((item, index) => {
          switch (item) {
            case 'fullname':
              $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
              $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
              break;
            default:
              $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
          }

        });
        return { $sort };
      }
      return null;
    },
    dataQuery() {
      return {
        ...this.query,
        ...this.extendedQuery,
        ...this.searchDataQuery,
        $limit: this.pagination.itemsPerPage,
        $skip: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        ...this.sortingQuery
      };
    },
    fetchQuery() {
      return Object.assign({}, {
        ...this.query,
        ...this.extendedQuery,
        // $populate: true
      }, {
        ...this.searchQuery,
        $limit: this.pagination.itemsPerPage,
        $skip: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        ...this.sortingQuery
      });
    },
  },
  methods: {
    escapeRegex(string) {
      return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    },
  }
}
</script>